export { Disclaimer } from "./styled";
